import * as React from 'react'

function CodeIcon(props) {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.67 5.333l-4.78 21.334M24.336 10.667L29.706 16l-5.37 5.333M8.224 21.333L2.854 16l5.37-5.333"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { CodeIcon }
